/*
 * Spelled out rather than imported from the app-home-screen constants: a fixture
 * in the api layer reaching into a page's module would be the wrong direction,
 * and this is the size every background is encoded to.
 */
const WIDTH = 1080;
const HEIGHT = 1920;

const escape = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/**
 * A stand-in for an asset the mocked CDN was asked for but never received.
 *
 * The mocked PUT discards its body, and msw cannot hand it back even if it kept
 * it — the generated worker reads every request body as text, so binary is
 * UTF-8 decoded and mangled before a handler sees it. So the read side draws
 * something instead.
 *
 * An svg rather than a bitmap because it needs no encoding, and it carries the
 * object key — which is the one thing that tells a default background apart from
 * a schedule override when several are on screen at once.
 */
export const mediaPlaceholderSvg = (key: string) => {
  const segments = key.split('/');
  const name = escape(segments[segments.length - 1]);
  const folder = escape(segments[segments.length - 2] ?? '');

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${WIDTH}" height="${HEIGHT}" viewBox="0 0 ${WIDTH} ${HEIGHT}">
  <defs>
    <pattern id="hatch" width="48" height="48" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
      <rect width="48" height="48" fill="#2c3440"/>
      <rect width="24" height="48" fill="#333c4a"/>
    </pattern>
  </defs>
  <rect width="100%" height="100%" fill="url(#hatch)"/>
  <text x="50%" y="46%" fill="#9fb0c4" font-family="monospace" font-size="52" text-anchor="middle">mocked asset</text>
  <text x="50%" y="52%" fill="#e2e8ef" font-family="monospace" font-size="40" text-anchor="middle">/${folder}/</text>
  <text x="50%" y="57%" fill="#e2e8ef" font-family="monospace" font-size="30" text-anchor="middle">${name}</text>
  <text x="50%" y="95%" fill="#7a8896" font-family="monospace" font-size="26" text-anchor="middle">${WIDTH} x ${HEIGHT}</text>
</svg>`;
};
